import { createContext, useContext } from 'react';

/**
 * Everything the settings screens need, in one place.
 *
 * Splitting one screen into seven would otherwise mean threading thirty-five
 * props through seven components — the list would grow with every screen
 * rather than shrink. The dashboard still owns the state; this only stops it
 * being carried by hand.
 */
export const SettingsCtx = createContext({});
export function useSettings() { return useContext(SettingsCtx); }
